// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_ADD_CUOTA,
} from './constants';

export function addCuota() {
  return {
    type: SIMULADOR_FINANCIERO_ADD_CUOTA,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_ADD_CUOTA:
      let id = Math.floor(Date.now() / 1000);
      let cuota = {
        id: id,
        plazo: '',
        montoMax: '',
        tna: '',
        valorCuotaPromedio: '',
        valorPrimeraCuota: null,
        porcMaxFinanciar: '',
        quebranto: '',
        gastos: '',
        cft: '',
        tir: '',
        showDelete: false,
        showEdit: false,
        newCuota: true,
        deleted: false
      };

      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        editLineaData.datosFinancieros.cuotas.push({ ...cuota });
        editLineaData.datosFinancieros.cuotasPreviousValues.push({ ...cuota });
        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        altaNuevaLinea.datosFinancieros.cuotas.push({ ...cuota });
        altaNuevaLinea.datosFinancieros.cuotasPreviousValues.push({ ...cuota });

        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }

    default:
      return state;
  }
}
